export function isMobile() {
  if (window.innerWidth < 1024) return true;
  return false;
}

let initialSize = isMobile();

window.onresize = function() {
  if (initialSize != isMobile()) location.reload();
};



// WEBPACK FOOTER //
// ./tools/mobileCheck.js